const UserChip = ({ name, initials, role }) => (
    <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white text-[12px] font-bold shadow-sm shrink-0">
            {initials || '?'}
        </div>
        <div className="hidden sm:flex flex-col leading-none">
            <span className="text-[12.5px] font-semibold text-slate-800 leading-none">{name}</span>
            {role && (
                <span className="text-[11px] text-slate-500 mt-1">{role}</span>
            )}
        </div>
    </div>
);

export default UserChip;
